const config = {
    apiUrl: process.env.REACT_APP_API_URL ?? 'http://timesheetapi.docker',
};

export default config;